// extracted by mini-css-extract-plugin
module.exports = {"banner":"adminBanner_banner__1Bkl1"};